__turbopack_context__.v({
  "slider": "DcA-ha_slider",
  "slider-container": "DcA-ha_slider-container",
  "slider__output": "DcA-ha_slider__output",
  "slider__output--light": "DcA-ha_slider__output--light",
  "slider__thumb": "DcA-ha_slider__thumb",
  "slider__thumb--is-dragging": "DcA-ha_slider__thumb--is-dragging",
  "slider__thumb--is-focused": "DcA-ha_slider__thumb--is-focused",
  "slider__track-style": "DcA-ha_slider__track-style",
  "slider__track-style--1": "DcA-ha_slider__track-style--1",
  "slider__track-style--10": "DcA-ha_slider__track-style--10",
  "slider__track-style--2": "DcA-ha_slider__track-style--2",
  "slider__track-style--3": "DcA-ha_slider__track-style--3",
  "slider__track-style--4": "DcA-ha_slider__track-style--4",
  "slider__track-style--5": "DcA-ha_slider__track-style--5",
  "slider__track-style--6": "DcA-ha_slider__track-style--6",
  "slider__track-style--7": "DcA-ha_slider__track-style--7",
  "slider__track-style--8": "DcA-ha_slider__track-style--8",
  "slider__track-style--9": "DcA-ha_slider__track-style--9",
});
